<template>
  <div id="app">
    <div class="navigation-bar">
      <div class="logo">
        <img :src="logoUrl" />
        <span class="m-left-1">{{ translate('title') }}</span>
      </div>
      <div>
        <div class="switch">
          <input v-model="checkBox" @click="changeLang" id="language-toggle" class="check-toggle check-toggle-round-flat" type="checkbox">
          <label for="language-toggle"></label>
          <span class="on">HU</span>
          <span class="off">EN</span>
        </div>
      </div>
    </div>

    <router-view :isTranslated=isTranslated />
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import NotAvailable from "./views/NotAvailable";

import {lang} from "@/lang";

export default {
  name: 'App',
  data() {
    return {
      logoUrl: window.location.origin + "/niszlogo.png",
      checkBox: false,
      isTranslated: window.localStorage.getItem("isTranslated") === "true",
    }
  },
  methods: {
    changeLang() {
      this.isTranslated = !this.isTranslated;
      window.localStorage.setItem("isTranslated", this.isTranslated);
    },
    translate(prop) {
      return this.isTranslated ? lang['en'][prop] : lang['hu'][prop]
    }
  },
  mounted() {
    this.checkBox = window.localStorage.getItem("isTranslated") === "true";
  }
  // components: {
  //   // HelloWorld
  //   NotAvailable
  // }
}
</script>

<style lang="scss">
@import "style/bulma-custom";
@import "style/utility/margins";
@import "./assets/fontawesome/css/all.css";

#app {
  position: absolute;
  top: 0;
  left: 0;

  height: 100%;
  width: 100%;

  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.57;
  background: $background;
  color: #323c50;
  text-align: left;

  .navbar {
    border-bottom: 1px solid #dcdcdc;
    height: $header-height;
    background: #f7f7f7;

    overflow: hidden;

    .navbar-brand {
      width: 100%;

      .navbar-burger {
        display: none;
      }

      img {
        max-height: 5rem;
        padding-left: 0.5rem;
      }

      span {
        color: #323c50;
        font-size: 1.7rem;
        font-weight: 400;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .title {
      font-weight: normal;
      text-transform: uppercase;
    }
  }

  h2 {
     text-align: center;
     font-size: 2rem;
     padding-top: 8rem;
  }

  h3 {
    text-align: center;
    font-size: 1.2rem;
    padding-top: 1.5em;
  }
}
</style>
